import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Mention } from 'mojo-editor';
import { Observable } from 'rxjs';

import { AssociationLabel, HiringManagerAggregation, MatchingParams } from '@shared/models';
import { Pagination } from '@shared/pagination';

import { Candidate } from '../models';
import { ApiRequest, ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SearchCandidatesService extends ApiService<Candidate> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'search/candidates/';
  }

  tags(jobId: number, search: string): Observable<Pagination<Mention>> {
    return super.get({ url: `tags?jobId=${jobId}&name=${search}` });
  }

  discover(): Observable<any> {
    return super.get({ url: 'discover' });
  }

  hiringManagerAggregation(
    request: Partial<ApiRequest<MatchingParams>>,
  ): Observable<HiringManagerAggregation> {
    return super.get({ ...request, url: 'hiring-manager-aggregation' });
  }

  shortlisted(
    request: Partial<ApiRequest<MatchingParams>>,
    statuses: string[],
    hmStatus: string[],
  ): Observable<Pagination<Candidate>> {
    const body = {
      statuses: !!statuses ? statuses : [],
      hmStatus: !!hmStatus ? hmStatus : [],
    };
    return super.post({ ...request, body, url: 'short-listed' });
  }

  rejected(request: Partial<ApiRequest<MatchingParams>>): Observable<Pagination<Candidate>> {
    return super.get({ ...request, url: 'rejected' });
  }

  matchedCount(request: Partial<ApiRequest<MatchingParams>>): Observable<number> {
    return super.post({
      url: `count/direct-candidates?v2&singleJob&jobId=${request.params.jobId}&excludeRejectedCandidates=true&excludeShortlist=true`,
      body: request.body,
    });
  }

  similar(candidateId: number, offset: number = 0, size: number = 8) {
    return super.post({
      url: `matched/ats?v2&matchBy=candidate&candidateId=${candidateId}&offset=${offset}&size=${size}`,
    });
  }

  matched(query: any) {
    if (query.params.category === AssociationLabel.DIRECT) {
      return super.post({
        url: `matched/direct?v2&jobId=${query.params.jobId}&offset=${
          query.params.offset
        }&size=${10}&sort=${
          query.params.sort
        }&withProspects=false&excludeShortlist=true&excludeRejectedCandidates=true`,
        body: query.body,
      });
    } else if (query.params.category === AssociationLabel.REFERRALS) {
      return super.post({
        url: `matched/referrals?v2&jobId=${query.params.jobId}&offset=${
          query.params.offset
        }&size=${10}`,
        body: query.body,
      });
    } else {
      return super.post({
        url: `matched/ats?v2&matchBy=job&jobId=${query.params.jobId}&offset=${
          query.params.offset
        }&size=${10}`,
        body: query.body,
      });
    }
  }
}
